// extracted by mini-css-extract-plugin
export default {"menu":"ChartContextMenu_menu__TGqt-"};